import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  IGroupAddEditDTO,
  IOptionDomainFormValues,
} from "../../Interfaces/optionDomain";

interface ISlice {
  addEditFormValues: IOptionDomainFormValues;
  tableRefetchFlag: boolean;
  isAddEditOpen: boolean;
  groupTableFlag: boolean;
  isAddEditGroupOpen: boolean;
  addEditGroupFormValues: IGroupAddEditDTO;
  isGroupEdit: boolean;
}

const initialState: ISlice = {
  addEditFormValues: {} as IOptionDomainFormValues,
  tableRefetchFlag: false,
  isAddEditOpen: false,
  isAddEditGroupOpen: false,
  addEditGroupFormValues: {} as IGroupAddEditDTO,
  groupTableFlag: false,
  isGroupEdit: false,
};

const OptionDomainSlice = createSlice({
  name: "optionDomain",
  initialState,
  reducers: {
    addEditOptionDomainFormValuesChangeHandler: (
      store,
      action: PayloadAction<{ name: string; value: any }>
    ) => {
      store.addEditFormValues = {
        ...store.addEditFormValues,
        [action.payload.name]: action.payload.value,
      };
    },
    setAddEditOptionDomainFormValues: (
      store,
      action: PayloadAction<IOptionDomainFormValues>
    ) => {
      store.addEditFormValues = action.payload;
    },
    addEditOptionDomainGroupFormValuesChangeHandler: (
      store,
      action: PayloadAction<{ name: string; value: any }>
    ) => {
      store.addEditGroupFormValues = {
        ...store.addEditGroupFormValues,
        [action.payload.name]: action.payload.value,
      };
    },
    setAddEditOptionDomainGroupFormValues: (
      store,
      action: PayloadAction<IGroupAddEditDTO>
    ) => {
      store.addEditGroupFormValues = action.payload;
    },
    setOptionDomainFlag: (store, action: PayloadAction<boolean>) => {
      store.tableRefetchFlag = action.payload;
    },
    setIsOptionDomainAddEditOpen: (store, action: PayloadAction<boolean>) => {
      store.isAddEditOpen = action.payload;
    },
    setIsOptionDomainAddEditGroupOpen: (
      store,
      action: PayloadAction<boolean>
    ) => {
      store.isAddEditGroupOpen = action.payload;
    },
    setOptionDomainGroupTableFlag: (store, action: PayloadAction<boolean>) => {
      store.groupTableFlag = action.payload;
    },
    setOptionDomainGroupEditFlag: (store, action: PayloadAction<boolean>) => {
      store.isGroupEdit = action.payload;
    },
  },
});

export const {
  addEditOptionDomainFormValuesChangeHandler,
  setAddEditOptionDomainFormValues,
  setOptionDomainFlag,
  setIsOptionDomainAddEditOpen,
  setIsOptionDomainAddEditGroupOpen,
  addEditOptionDomainGroupFormValuesChangeHandler,
  setAddEditOptionDomainGroupFormValues,
  setOptionDomainGroupTableFlag,
  setOptionDomainGroupEditFlag,
} = OptionDomainSlice.actions;
export default OptionDomainSlice.reducer;
